import script from "./OurTutors.vue?vue&type=script&setup=true&lang=js"
export * from "./OurTutors.vue?vue&type=script&setup=true&lang=js"

import "./OurTutors.vue?vue&type=style&index=0&id=3650b8cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3650b8cc"]])

export default __exports__